import React, { useRef, useState, useEffect } from "react";
import "./ScrollTag.css"
import { TbLayersSelectedBottom } from "react-icons/tb";
const ScrollTag = ({whereFrom,  tagList, showBlog, hide_from_mobile,  selectedTag, onTagClick , tagColorClass}) => {
  // Ref for the scrollable container
  const ScrollDivTags = useRef(null);
  const [isAtStart, setIsAtStart] = useState(true);
  function nextTag() {
    const container = ScrollDivTags.current;
    if (container) {
        const scrollAmount = window.innerWidth <= 680 ? 380 : 800;
      container.scrollLeft += scrollAmount; // Adjust the scroll amount as needed
      hideLeftArrow();
    }
  }
  const hideLeftArrow = () => {
    const container = ScrollDivTags.current;
    if (container) {
      setIsAtStart(container.scrollLeft === 0);
    }
  };
  function prevTag() {
    const container = ScrollDivTags.current;
    if (container) {
      const scrollAmount = window.innerWidth <= 680 ? 380 : 800;
      container.scrollLeft -= scrollAmount; // Adjust the scroll amount as needed
      hideLeftArrow();
    }
  }
  useEffect(() => {
    const container = ScrollDivTags.current;
    if (container) {
      container.addEventListener("scroll", hideLeftArrow);
    }
    return () => {
      if (container) {
        container.removeEventListener("scroll", hideLeftArrow);
      }
    };
  }, []);
  
  function sendClickFeed(event){    
    let shareButton = event.target;
    if(shareButton){
      shareButton.style.backgroundColor = "rgba(43, 52, 69, 0.1)";
      // shareButton.firstElementChild.style.color = "white";
      shareButton.style.transform = "scale(0.9)";
      
      // shareButton.firstElementChild.style.backgroundColor = "white";
    }
    
  }
  function removeClickFeed(event){    
    let shareButton = event?.target;
    if(shareButton){
      // shareButton.style.backgroundColor = "#ffffff";
      shareButton.style.transform = "scale(1)";
      // shareButton.firstElementChild.style.color = "";
      // shareImage(imageUrl)
          showBlog();
      
    }
    
  }
  
  const normalizeCaption = (val) =>{
  return String(val || "")
    .normalize("NFKD")                // normalize unicode
    .replace(/[\u{1F300}-\u{1FAFF}]/gu, "") // remove emojis
    .replace(/[^\w\s:]/g, "")         // remove special characters
    .trim()
    .toLowerCase();
  }

//   useEffect(() => {
//   if (!selectedTag) return;

//   const container = ScrollDivTags.current;
//   if (!container) return;
// console.log("scrolldiv", container, selectedTag)
//   const allTags = container.querySelectorAll("[data-tag]");

//   let target = null;


//   allTags.forEach((el) => {
//     const tagValue = el.getAttribute("data-tag");
//     console.log("caption tag",  selectedTag)
//     if (normalizeCaption(tagValue) === normalizeCaption(selectedTag)) {
//       target = el;
//     }
//   });

//   if (target) {
// //  console.log("target rect", target?.getBoundingClientRect());
      
//         target.scrollIntoView({
//             behavior: "smooth",
//             inline: "center",
//             block: "nearest",
            
//           });
      
//   }




// }, [selectedTag]);



useEffect(() => {
  if (!selectedTag) return;
  
  const container = ScrollDivTags.current;
  if (!container) return;

  const scrollToTag = () => {
    // const target = container.querySelector(`[data-tag]`);
    const allTags = container.querySelectorAll("[data-tag]");

    let matched = null;

    allTags.forEach((el) => {
      const tagValue = el.getAttribute("data-tag");

      if (normalizeCaption(tagValue) === normalizeCaption(selectedTag)) {
        matched = el;
        matched.classList.add('highlight_tag')
        
      }
    });

    if (!matched) return;

    const scrollLeft =
      matched.offsetLeft -
      container.clientWidth / 2 +
      matched.clientWidth / 2;

    container.scrollTo({
      left: scrollLeft,
      behavior: "smooth",
    });
  };

  // wait for layout on mobile
  requestIdleCallback
    ? requestIdleCallback(scrollToTag)
    : setTimeout(scrollToTag, 100);

}, [selectedTag, tagList]);


  function orignalElement(event){
    let shareButton = event?.target;
    if(shareButton){
      // shareButton.style.backgroundColor = "#ffffff";
      shareButton.style.transform = "scale(1)";
      // shareButton.firstElementChild.style.color = "";         
    }    
  }
  
  const [blogDetailShowHeaderInfo, setBlogDetailShowHeaderInfo] = useState(true);

function shouldShowSavedHint() {
  // const exists = sessionStorage.getItem("shownSavedExploreHint");
  let backheader = document.querySelector('.back_header') 
  if(!backheader) return

  if(backheader)
    console.log("back-header", backheader, backheader.offsetHeight)
    if(backheader.offsetHeight === 59){
      setBlogDetailShowHeaderInfo(false)
    }else{
      setBlogDetailShowHeaderInfo(true)

      
    }
  
}

useEffect(()=>{
  if(whereFrom !== "exploreNext") return

  shouldShowSavedHint()

}, [tagList])


  return (
    <>
      <div
        className={`container d-flex align-items-center st_blog_tag_suggestion position-relative p-0 app_container  ${whereFrom === "exploreNext" ? "explore_auto" : ""} `}
        style={{ height: blogDetailShowHeaderInfo ? "55px" :  whereFrom === "exploreNext" ? "45px" : "60px" }}
      >
        {(whereFrom !== "exploreNext" && !isAtStart) && (
          <i
            class="fa-solid fa-angle-left position-absolute app_blog_tag_left app_explore_tag_left hide_from_mobile"
            onClick={prevTag}
          ></i>
        )}
      

        <div
          // className={`d-flex align-items-center blog_tag_suggestion  ${whereFrom === "exploreNext" ? 'image_chips_container container' : ''} ${blogDetailShowHeaderInfo ? 'big_top' : ''}`}
          className={`d-flex align-items-center blog_tag_suggestion ${whereFrom === "exploreNext" ? 'image_chips_relative container' : ''} ${blogDetailShowHeaderInfo ? 'big_top' : ''}`}
          ref={ScrollDivTags}
          style={{ 
            scrollBehavior: "smooth",
            
          
           }}
        >
        

       {whereFrom === "blogs" &&  <span className="d-flex" ><i className="fa-solid fa-house blog_home" onMouseDown={sendClickFeed} onMouseUp={removeClickFeed} onMouseOut={orignalElement}></i></span>}
          {/* {tagList?.map((tag, index) => {
            return (
              <span key={index} tabIndex="0" 
              className={(whereFrom === "captions") ? "app_blog_tag_text app_explores_tag_text" : "app_blog_tag_text"}
              >
                {tag.charAt(0).toUpperCase() + tag.slice(1)}
              </span>
            );
          })} */}


          {tagList?.map((tag, index) => {
            

  const formattedTag =
    tag.charAt(0).toUpperCase() + tag.slice(1);

 const isSelected =
  String(selectedTag || "")
    .trim()
    .toLowerCase() ===
  String(tag || "")
    .trim()
    .toLowerCase();

  return (
    <span
      key={index}
      tabIndex="0"
      data-tag={tag}   // 👈 important
        onClick={(e) =>{
         if(whereFrom === "exploreNext") {
           onTagClick(tag, index)
         }else{
           onTagClick(tag)
         }
        }}
        
      className={`
        ${(whereFrom === "captions")
          ? "app_blog_tag_text app_explores_tag_text"
          : "app_blog_tag_text" }
        ${isSelected ? "highlight_tag" : ""}

        ${whereFrom === "exploreNext" ? tagColorClass : ''}
      `}
    >
      {formattedTag}
    </span>
  );
})}
        </div>

      {whereFrom !== "exploreNext" && (<>
        
        <i
          class="fa-solid fa-angle-right position-absolute app_blog_tag_right app_explore_tag_right hide_from_mobile"
          onClick={nextTag}
        ></i>

      </>)}

      </div>
    </>
  );
};

export default ScrollTag;
